import { render, staticRenderFns } from "./SAAS_AGB.vue?vue&type=template&id=6ee80f97&"
import script from "./SAAS_AGB.vue?vue&type=script&lang=js&"
export * from "./SAAS_AGB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports